import React from "react";
import AudienceMap from "../../../components/complex/AudinceMap";

import styles from "./map.module.scss";

export default function Map(props) {
  return (
    <div className={styles.map}>
      <AudienceMap {...props} />
    </div>
  );
}
